import React from 'react'
import DetailCardWithTable from '../../../dpe-usco/components/Details/DetailCardWithTable'
import TableStatus from '../../../components/subComponents/TableStatus/TableStatus'
import { BEEF_MULTIPLIER, DAIRY_MULTIPLIER } from '../../../services/config'
import { convertToTitleCase } from '../../../services/utils'
import {
  convertToSentenceCase
} from '../../../services/utils'
import TabbedTable from '../../../components/TabbedTable/TabbedTable'
import Widget from '../../../dpe-usco/components/Widget/Widget'

export const DeliveryCard = ({ data, isFedOnFarm, status, contract_year, class_name = '' }) => {
   

 
  if(data && !isFedOnFarm) {

    const contractType = ['grain','silage','earlage','high moisture']
    const contractYear = parseInt(contract_year.split('-')[0])
    const nextYear = contractYear + parseInt(1)
    const totalMonth = [
      { 
        delivery_month: 'september',
        delivery_year: contractYear
      },
      { 
        delivery_month: 'october',
        delivery_year: contractYear
      },
      { 
        delivery_month: 'november',
        delivery_year: contractYear
      },
      { 
        delivery_month: 'december',
        delivery_year: contractYear
      },
      { 
        delivery_month: 'january',
        delivery_year: nextYear
      },
      { 
        delivery_month: 'february',
        delivery_year: nextYear
      },
      { 
        delivery_month: 'march',
        delivery_year: nextYear
      },
      { 
        delivery_month: 'april',
        delivery_year: nextYear
      },
      { 
        delivery_month: 'may',
        delivery_year: nextYear
      },
      { 
        delivery_month: 'june',
        delivery_year: nextYear
      },
      { 
        delivery_month: 'july',
        delivery_year: nextYear
      },
      { 
        delivery_month: 'august',
        delivery_year: nextYear
      },
      { 
        delivery_month: 'september',
        delivery_year: nextYear
      }
    ]

    let templateData = []

    contractType.forEach(contractTypeVal => {
      totalMonth.forEach(monthVal => {
        templateData.push({
          available_acres: null,
          contract_acres: null,
          contract_units: null,
          delivery_month: monthVal.delivery_month,
          delivery_type: contractTypeVal,
          delivery_year: monthVal.delivery_year
        })
      })
    })

    if(data.length > 0) {
      templateData.forEach(field => {
        if(field.delivery_type === 'grain'){
          const grainFilterIndex = data.findIndex(elem => {
            return (elem.delivery_month === field.delivery_month 
              && elem.delivery_year === field.delivery_year 
              && elem.delivery_type === 'grain'
            )
          })
         
          if(grainFilterIndex !== -1) {
            Object.assign(field, data[grainFilterIndex])
          } 
        }

        if(field.delivery_type === 'silage'){
          const silterFilterindex = data.findIndex(elem => {
            return (elem.delivery_month === field.delivery_month 
              && elem.delivery_year === field.delivery_year 
              && elem.delivery_type === 'silage'
            )
          })
          if(silterFilterindex !== -1) {
            Object.assign(field, data[silterFilterindex])
          } 
        }

        if(field.delivery_type === 'earlage'){
          const earlageFilterIndex = data.findIndex(elem => {
            return (elem.delivery_month === field.delivery_month 
              && elem.delivery_year === field.delivery_year 
              && elem.delivery_type === 'earlage'
            )
          })
          if(earlageFilterIndex !== -1) {
            Object.assign(field, data[earlageFilterIndex])
          }
        }

        if(field.delivery_type === 'high moisture'){
          const highmoistureFilterIndex = data.findIndex(elem => {
            return (elem.delivery_month === field.delivery_month 
              && elem.delivery_year === field.delivery_year 
              && elem.delivery_type === 'high moisture'
            )
          })

          if(highmoistureFilterIndex !== -1) {
            Object.assign(field, data[highmoistureFilterIndex])
          } 
        }
      })
    }   
    data = [...templateData]
    data = data.map(contractMonth => {
      return  {
        ...contractMonth,
        delivery_month : `${convertToSentenceCase(contractMonth.delivery_month.substring(0,3))}-${contractMonth.delivery_year.toString().substring(2,4)}`
      }
    })
  } 
 

  const headerCell = value => {
    return (
      <div key={value} className='cell df aic'>
        <span>{value}</span>
      </div>
    )
  }

  const formatsCommericalFeedOrFuel = array => {
    return array && array.map(obj => {
      obj.delivery_type = convertToTitleCase(obj.delivery_type)
      obj.delivery_month = convertToTitleCase(obj.delivery_month)
      return obj
    })
  }
  
  const structure = {
    headers: [
      { 
        value: 'Delivery month',
        format(){
          return headerCell(this.value)
        }
      },
      { 
        value: 'Contract acres',
        format(){
          return headerCell(this.value)
        }
      },
      { 
        value: 'Contract units',
        format(){
          return headerCell(this.value)
        }
      }
    ],
    dataKeys: [
      'delivery_month',
      'contract_acres',
      'contract_units'
    ]
  }

  if (isFedOnFarm) {
    structure.headers = [
      {
        value: 'Cattle Type',
        format(){
          return headerCell(this.value)
        }
      },
      { 
        value: 'Cattle Headcount',
        format(){
          return headerCell(this.value)
        }
      },
      { 
        value: 'Bushel',
        format(){
          return headerCell(this.value)
        }
      }
    ]
    
    structure.dataKeys = [
      'cattle_type',
      'unit_count',
      'bushels'
    ]

    data = data && data.map(obj => {
      if (obj.cattle_type && obj.cattle_type.toLowerCase() === 'dairy') {
        obj.bushels = DAIRY_MULTIPLIER * obj.unit_count
      } else {
        obj.bushels = BEEF_MULTIPLIER * obj.unit_count
      }
      obj.cattle_type = convertToTitleCase(obj.cattle_type)
      return obj
    })
  } else {
    formatsCommericalFeedOrFuel(data)
  }

  const formatDataType = (array, type) => {
    const filterArr = []
    array && array.forEach(obj => {
      if(obj.delivery_type === convertToTitleCase(type)){
        filterArr.push(obj)
      }
    })
    return filterArr
  }

  const tabGenerator = type => {
    const value = convertToSentenceCase(type)
    const sendData = formatDataType(data,type)
    return {
      value,
      data: sendData || [],
      structure: structure
    }
  }

  const generateTabs = () => {
    return [
      tabGenerator('grain'),
      tabGenerator('silage'),
      tabGenerator('earlage'),
      tabGenerator('high moisture')
    ]
  }

  const tabs = generateTabs()
  
  return (
    <div className={class_name}>
      {isFedOnFarm ?
        <DetailCardWithTable dataTestId={'deliveryTable'} title={'Delivery'} structure={structure} data={data || []} statusComponent={status ? <TableStatus status={status}/> : null} tabs={tabs} />
        :
        <Widget title="Delivery">
          <TabbedTable
            IsInputTable={false}
            editMode={false}
            tabs={tabs}
            statusComponent={status ? <TableStatus status={status}/> : null}
          />
        </Widget>
      }
    </div>
  )
}

export default DeliveryCard